module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-ingredient-du-mois-avocat.be28c3d2.jpg";